/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleBigQueryGa4PseudonymousUsersReportDailyData
 */
export interface GoogleBigQueryGa4PseudonymousUsersReportDailyData {
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportDailyData
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportDailyData
     */
    changedPseudonymousIdentifiers?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportDailyData
     */
    activePseudonymousIdentifiers?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportDailyData
     */
    firstTouchPseudonymousIdentifiers?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportDailyData
     */
    firstPurchasePseudonymousIdentifiers?: number;
}

/**
 * Check if a given object implements the GoogleBigQueryGa4PseudonymousUsersReportDailyData interface.
 */
export function instanceOfGoogleBigQueryGa4PseudonymousUsersReportDailyData(value: object): value is GoogleBigQueryGa4PseudonymousUsersReportDailyData {
    return true;
}

export function GoogleBigQueryGa4PseudonymousUsersReportDailyDataFromJSON(json: any): GoogleBigQueryGa4PseudonymousUsersReportDailyData {
    return GoogleBigQueryGa4PseudonymousUsersReportDailyDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4PseudonymousUsersReportDailyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4PseudonymousUsersReportDailyData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'changedPseudonymousIdentifiers': json['changedPseudonymousIdentifiers'] == null ? undefined : json['changedPseudonymousIdentifiers'],
        'activePseudonymousIdentifiers': json['activePseudonymousIdentifiers'] == null ? undefined : json['activePseudonymousIdentifiers'],
        'firstTouchPseudonymousIdentifiers': json['firstTouchPseudonymousIdentifiers'] == null ? undefined : json['firstTouchPseudonymousIdentifiers'],
        'firstPurchasePseudonymousIdentifiers': json['firstPurchasePseudonymousIdentifiers'] == null ? undefined : json['firstPurchasePseudonymousIdentifiers'],
    };
}

export function GoogleBigQueryGa4PseudonymousUsersReportDailyDataToJSON(json: any): GoogleBigQueryGa4PseudonymousUsersReportDailyData {
    return GoogleBigQueryGa4PseudonymousUsersReportDailyDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4PseudonymousUsersReportDailyDataToJSONTyped(value?: GoogleBigQueryGa4PseudonymousUsersReportDailyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'changedPseudonymousIdentifiers': value['changedPseudonymousIdentifiers'],
        'activePseudonymousIdentifiers': value['activePseudonymousIdentifiers'],
        'firstTouchPseudonymousIdentifiers': value['firstTouchPseudonymousIdentifiers'],
        'firstPurchasePseudonymousIdentifiers': value['firstPurchasePseudonymousIdentifiers'],
    };
}

